import React from "react";

const AppML_PHP = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML PHP</h1>
      <p>This is the AppML PHP page content.</p>
    </div>
  );
};

export default AppML_PHP;
